// extracted by mini-css-extract-plugin
export var heading_text = "whatWeDoMenu-module--heading_text--26bb1";
export var inner_menu = "whatWeDoMenu-module--inner_menu--d3e59";
export var menuBox = "whatWeDoMenu-module--menuBox--1798f";
export var mobile_header = "whatWeDoMenu-module--mobile_header--a9bbd";
export var sub_menu = "whatWeDoMenu-module--sub_menu--7896b";
export var sub_menu_col_left = "whatWeDoMenu-module--sub_menu_col_left--78a88";
export var sub_menu_col_right = "whatWeDoMenu-module--sub_menu_col_right--f7ef6";
export var sub_menu_inner = "whatWeDoMenu-module--sub_menu_inner--ca2a1";
export var sub_menu_link = "whatWeDoMenu-module--sub_menu_link--66146";
export var sub_menu_list_industries = "whatWeDoMenu-module--sub_menu_list_industries--7f27b";
export var sub_menu_listing = "whatWeDoMenu-module--sub_menu_listing--bca0c";
export var sub_menu_wrapper = "whatWeDoMenu-module--sub_menu_wrapper--91448";
export var tech_sub_menu_box = "whatWeDoMenu-module--tech_sub_menu_box--d6341";
export var tech_sub_menu_wrap = "whatWeDoMenu-module--tech_sub_menu_wrap--a1760";
export var tech_sub_wrap = "whatWeDoMenu-module--tech_sub_wrap--65bd0";
export var text_div = "whatWeDoMenu-module--text_div--eb120";
export var what_we_do_menu = "whatWeDoMenu-module--what_we_do_menu--3c891";